import React from 'react';
import Text from '../ui/text';

export default function Title({ title, subtitle }) {
  return (
    <Text
      title
      weight="med"
      size="lg"
      tag="h1"
      id="gtm-title"
      className="product-summary__heading"
    >
      {title}
      {subtitle && ` – ${subtitle}`}
    </Text>
  );
}



// WEBPACK FOOTER //
// ./shared/components/product/title.js